import styled, { css } from 'styled-components'

import { color, space } from 'theme/utils'

export const Container = styled.div<{ noScroll?: boolean }>`
  --modal-header-height: 84px;
  background: ${color('overlay')};
  bottom: 0;
  color: white;
  height: 100%;
  left: 0;
  min-height: var(--vh);
  ${({ noScroll }) =>
    !noScroll &&
    css`
      overflow-y: scroll;
    `}
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  z-index: 200;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const Header = styled.header`
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
  > div {
    align-items: center;
    display: flex;
    flex-direction: row;
    height: var(--modal-header-height);
    justify-content: flex-end;
    margin: 0 auto;
    padding: 0 ${space(4)};
    width: 100%;

    > button {
      align-self: flex-start;
      margin-top: ${space(3)};
    }
  }
`

export const modalBodyStyles = css`
  margin: var(--modal-header-height) auto ${space(4)};
  max-width: 900px;
  padding: 0 ${space(6)} ${space(24)};

  @media only screen and (min-width: 650px) {
    padding-top: ${space(6)};
  }

  &.noHorizontalPadding {
    padding-left: 0;
    padding-right: 0;
  }
`
export const ModalBody = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${modalBodyStyles}
`
